import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChainDropdownComponent } from './chain-dropdown.component';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
  ],
  declarations: [ChainDropdownComponent],
  exports: [ChainDropdownComponent]
})
export class ChainDropdownModule { }
